import { BASE_URL } from '../config'
import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

const url = `${BASE_URL}/product-analytics`

type VerticalID = { vertical_id: number }

export const getPopularVerticals = async (): Promise<
  ApiResponseV2<{ response: VerticalID[] }>
> => {
  try {
    const response = await axios.get(`${url}/popular_verticals`)
    return extract.data(response)
  } catch (error) {
    return {
      status: 'error',
      data: null,
      error: error.message
    }
  }
}
